import { Dimension } from '@/services/dimension/dimension.model'
import { createDimension, updateDimension } from '@/services/dimension/dimension.service'
import { EditOutlined } from '@ant-design/icons'
import { Button, Descriptions, Form, Input, Space } from 'antd'
import { memo, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

interface DimensionFormProps {
  dimension: Dimension.Info | undefined
  isCreate: boolean
  refreshDimension: () => void
}

const DimensionForm = memo<DimensionFormProps>((props) => {
  const { dimension, isCreate, refreshDimension } = props
  const [form] = Form.useForm()
  const [isEdit, setIsEdit] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (dimension) {
      form.setFieldsValue(dimension)
    }
  }, [dimension])

  const onFinishHandler = async (values) => {
    if (isCreate) {
      const data = await createDimension(values)
      navigate(`../${data.id}`)
    }

    if (isEdit) {
      await updateDimension(dimension!.id, values)
      refreshDimension()
      setIsEdit(false)
    }
  }

  if (dimension && !isEdit) {
    return (
      <Descriptions>
        <Descriptions.Item label='Code'>
          <Space>
            {dimension.code} <EditOutlined onClick={() => setIsEdit(true)} style={{ cursor: 'pointer' }} />
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label='Description'>
          <Space>
            {dimension.description} <EditOutlined onClick={() => setIsEdit(true)} style={{ cursor: 'pointer' }} />
          </Space>
        </Descriptions.Item>
      </Descriptions>
    )
  }

  return (
    <Form form={form} layout='inline' onFinish={onFinishHandler}>
      <Space>
        <Form.Item
          name='code'
          label='Code'
          required={false}
          rules={[{ required: true, message: 'Please input code' }]}
        >
          <Input type='text' />
        </Form.Item>

        <Form.Item
          name='description'
          label='Description'
          required={false}
          rules={[{ required: true, message: 'Please input description' }]}
        >
          <Input type='text' />
        </Form.Item>

        <Form.Item>
          {isCreate && (
            <Space>
              <Button type='primary' htmlType='submit'>
                Create
              </Button>

              <Button onClick={() => navigate('..')}>Cancel</Button>
            </Space>
          )}
          {isEdit && (
            <Space>
              <Button type='primary' htmlType='submit'>
                Save
              </Button>

              <Button onClick={() => setIsEdit(false)}>Cancel</Button>
            </Space>
          )}
        </Form.Item>
      </Space>
    </Form>
  )
})

export default DimensionForm
